export enum SurveyInputType {
  SELECT = "select",
  SELECT_COUNTRY = "select-country",
  SELECT_MUNICIPALITY = "select-city",
  SELECT_CITY_BIRTH_PLACE = "select-city-birth-place",
  SELECT_CITY_AFFILIATED = "select-city-affiliated",
  SELECT_STUDY_LEVEL = "select-study-level",
  RADIO = "radio",
  BOOLEAN = "boolean",
  RESIDENCE_PERMIT_TYPE = "residence-permit-type",
  RADIO_WITH_PREVIEW = "radio:with-preview",
  INPUT_PERCENTAGE = "input:number-percentage",
  INPUT_DATE = "input:date",
  INPUT_DATE_BOUNDED = "input:date-bounded",
  INPUT_DATE_OF_BIRTH = "input:date-of-birth",
  INPUT_DATE_OF_BIRTH_ALLOW_MISMATCH = "input:date-of-birth-allow-mismatch",
  INPUT_DATA_OF_BIRTH_ALLOW_MINOR = "input:date-of-birth-allow-minor",
  INPUT_STRING = "input:string",
  INPUT_STRING_WITHOUT_VALIDATION = "input:string-without-validation",
  INPUT_TAXCODE = "input:taxcode",
  CHECKBOX_INITIAL_CONSENSUS = "checkbox:initial-consensus",
  INPUT_HIDDEN = "input:hidden",
  INPUT_ADOPTION_YEAR = "input:adoption-year",
  INPUT_CURRENCY = "input:currency",
  INPUT_YEAR = "input:year",
  INPUT_CHIP = "input:chip",
}

export enum SurveyActionType {
  SKIP = "skip",
  NEXT = "next",
  BACK = "back",
  CLEAR = "clear",
  CTA = "cta",
}

export type SurveyCtaVariant = "contained" | "outlined";

export interface SurveyCtaAction {
  type: SurveyActionType.CTA;
  label: string;
  destination: string;
  variant: SurveyCtaVariant;
}

export type SurveyAction = { type: SurveyActionType } | SurveyCtaAction;

export const DATE_FORMAT = "yyyy-MM-dd";
export const DATE_FORMAT_MOMENT = "yyyy-MM-DD";
export const DATE_DISPLAY_FORMAT = "dd/MM/yyyy";
export const YEAR_FORMAT = "yyyy";
